import React from 'react';
import PropTypes from 'prop-types'
import styled, { keyframes } from 'styled-components';

import { getFromattedPreset } from '../../selectors/entities/filters';
import { Client } from '../../client';

import BuilderCanvas from '../BuilderCanvas';
import ClearIcon from '../../components/icons/ClearIcon';
import RubleLightIcon from '../icons/RubleLightIcon';

const sampleShirtImage = '/images/builder/shirtCatalogSample.png'

const RiseAnimation = (isMobile) => keyframes`
    0% {
        transform:scale(0.4);
        opacity: 0;
        ${!isMobile ?
            `left: 77vw;`
            : `
            right: 15px;`}
        top: 50px;
    }
    100% {
        opacity: 1;
        transform:scale(1);
        z-index: 99;
        top: 50px;
        ${!isMobile ?
            `left: 77vw;`
            : `
            right: 15px;`}
        }
`;

const ProductWidget = styled.div`
    font-size: 12px;
    position: fixed;
    width: 260px;
    background: white;
    padding: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border: 1px solid #C4C4C4;
    border-radius: 2px;
    z-index: 11;
    animation: ${props => RiseAnimation(props.isMobile)};

    animation-duration: 0.3s;
    animation-timing-function:cubic-bezier(.46,.46,.28,1);
    animation-fill-mode: forwards;
`;


const ContentWrapper = styled.div`
     
`;

const Preview = styled.div`
    display: flex;
`;

const Price = styled.p`
    margin: 5px 0px;
`;

const OfferButton = styled.button`
    background: black;
    outline: none;
    color: white;
    border: 0px;
    padding: 10px 20px;
    margin: 5px 0px 0;
    width: 100%;
    text-transform: uppercase;

    &:hover {
        cursor: pointer;
        background: #c4c4c4;
        transition: 0.25s;
        transition-property: 'background-color';
    }
`

const Fabric = styled.p`
    margin-top: 15px;
`

const Heading = styled.h4`
    border-bottom: 1px solid gainsboro;
    color: #888;
    text-transform: uppercase;
    border-bottom: 1px solid #E3E3E3;
    padding-bottom: 10px;
    margin-bottom: 5px;
    line-height: normal;
`;

const Description = styled.div`
    margin-left: 12px;
`

const CloseButton = styled.button`
    padding: 5px;
    margin: 0 0 0 auto;
    border: none;
    box-sizing: border-box;
    background-color: transparent;
    cursor: pointer;
    outline: none;
    position: absolute;
    z-index: 2;
    right: 8px;
    top: 8px;
`

const Image = styled.img`
    /* height: ${props => props.isMobile ? '101px' : '100%'}; */
    height: 100%;
    width: 75px;
`

const onImageError = (e) => {
    console.info(`%cПотярл текстуру: ${e.target.src}`, 'color: blue; font-weight: bold;');
    e.target.src = sampleShirtImage;
}

const CanvasWrapper = styled.div`
    height: ${props => props.isMobile ? `140px;` : `auto;`};;
    width: ${props => props.isMobile ? `auto;` : `75px;`};
    ${props => props.isMobile && {margin: `-20px 0`}}
`;


const Widget = ({ show, price, fabric, type, isMobile, onClose, article, preset }) => (
    !show ? null
        :
        (
            <ProductWidget isMobile={isMobile} >
                <Heading>
                    ДОБАВЛЕНО В КОРЗИНУ
                    <CloseButton
                        onClick={onClose}>
                        <ClearIcon style={isMobile ? {width:'1em', height:'1em'} : {width:'1.25em', height:'1.25em'}} />
                    </CloseButton>
                </Heading>
                <ContentWrapper>
                    <Preview>
                        {type === 'builder' && 
                            <CanvasWrapper isMobile={isMobile}>
                                <BuilderCanvas type='xsmall'/>
                            </CanvasWrapper>
                        }
                        {type === 'catalog' && 
                            <Image 
                                src={Client.getCatalogPresetsImageUrl(article.toLowerCase(), getFromattedPreset(preset), 'xsmall')}
                                onError={onImageError}
                                isMobile={isMobile}/>
                        }
                        <Description>
                            <Fabric>{fabric}</Fabric>
                            <Price>
                                {price}&#160;
                                <RubleLightIcon size={9} color='currentColor'/>
                            </Price>
                        </Description>
                    </Preview>
                    <OfferButton onClick={() => { window.location = '/cart'; }}>Оформить заказ</OfferButton>
                </ContentWrapper>
            </ProductWidget>
        )
)

Widget.propTypes = {
    show: PropTypes.bool.isRequired, 
    price: PropTypes.number.isRequired,
    fabric: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    isMobile: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    article: PropTypes.string.isRequired,
    preset: PropTypes.string.isRequired
}

export default Widget;